import React from 'react'
import { Link } from 'react-router-dom'

export default function Home() {
  return (
    <div>
      <div>Welcome to home page
        
      </div>
    </div>
  )
}
